var map = {
	"./ar.png": 808,
	"./blank-language.png": 809,
	"./en.png": 810,
	"./id.png": 811,
	"./ru.png": 812,
	"./th.png": 813,
	"./vi.png": 814,
	"./zh-cn.png": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1846;